import React from 'react'


const OutputType = React.lazy(() => import("pages/OutputType/pages/OutputTypePage"))
const OutputTypeAdd = React.lazy(() => import("pages/OutputType/pages/OutputTypeAdd"))
const OutputTypeDetail = React.lazy(() => import("pages/OutputType/pages/OutputTypeDetail"))
const OutputTypeEdit = React.lazy(() => import("pages/OutputType/pages/OutputTypeEdit"))


const OutputTypeRoutes = [

    {
        path: "/output-type",
        exact: true,
        name: "Hình thức xuất bán",
        function: "SL_OUTPUTTYPE_VIEW",
        component: OutputType,
    },
    {
        path: "/output-type/add",
        exact: true,
        name: "Thêm mới",
        function: "SL_OUTPUTTYPE_ADD",
        component: OutputTypeAdd,
    },
    {
        path: "/output-type/detail/:id",
        exact: true,
        name: "Chi tiết",
        function: "SL_OUTPUTTYPE_VIEW",
        component: OutputTypeDetail,
    },
    {
        path: "/output-type/edit/:id",
        exact: true,
        name: "Chỉnh sửa",
        function: "SL_OUTPUTTYPE_EDIT",
        component: OutputTypeEdit,
    },

]

export default OutputTypeRoutes
